import { Header16, Header24, Header32, Header40, Paragraph16 } from '../styles/typography'
import { SimpleLink } from '../components/atoms/link'
import styled from '@emotion/styled'
import { Footer } from '../components/atoms/footer'
import { Testimonials } from '../sections/Testimonials'
import { NavBar } from '../components/atoms/header'
import { HeroBackground, HeroContent, HeroMainHeader, ImageWrapper } from '../components/atoms/pageHero'
import heroImage from '../assets/images/projects/project3.jpg'
import { Contact } from '../sections/Contact'
import whiteLine from '../assets/images/vertical-line.png'
import profileImage from '../assets/images/about-portrait.png'
import { Background, MainContainer, ProfileContainer, ProfileImageWrapper, TextContainer } from '../components/about'
import { useEffect } from 'react'
import { Policies } from '../policy'

const PolicyWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 40px;
`

const PolicyItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    h3 {
        color: ${(props) => props.theme.primaryColor.blue[3]};
        font-family: Inter-Medium;
        font-size: 18px;
        font-weight: 800;
        line-spacing: 4%;
        margin: unset;
    }

    p {
        // color: ${(props) => props.theme.primaryColor.grey[3]};
        font-family: Inter-Light;
        font-size: 16px;
        font-weight: 200;
        margin: unset;
    }
`

const PolicyContent = styled.p`
    font-size: 16px;
    line-height: 1.5;
`

export function PrivacyPolicy() {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div>
            <NavBar />
            <HeroBackground>
                <HeroMainHeader>
                    <HeroContent>
                        <img src={whiteLine} style={{ height: '40px' }} />
                        <Header40 style={{ color: '#ffffff' }}>Privacy Policy</Header40>
                    </HeroContent>
                </HeroMainHeader>
                <ImageWrapper src={heroImage} />
            </HeroBackground>

            <Background>
                <MainContainer>
                    <PolicyWrapper>
                        {Policies.map((policy, index) => (
                            <PolicyItem key={index}>
                                <h3>
                                    {index + 1}. {policy.title}
                                </h3>
                                <p>{policy.content}</p>
                            </PolicyItem>
                        ))}
                    </PolicyWrapper>
                </MainContainer>
            </Background>

            <Footer />
        </div>
    )
}
